import { render } from "./DonationsTab.vue?vue&type=template&id=04f9afdf&scoped=true"
import script from "./DonationsTab.vue?vue&type=script&lang=js"
export * from "./DonationsTab.vue?vue&type=script&lang=js"

import "./DonationsTab.vue?vue&type=style&index=0&id=04f9afdf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04f9afdf"]])

export default __exports__